interface NavigationItems {
  name: string;
  link: string;
  active?: boolean;
}

export const NavigationItems: NavigationItems[] = [
  { name: "The concept", link: "/" },
  { name: "e-Health now", link: "/e-health-now" },
  { name: "Partnerships", link: "/partnerships" },
  { name: "In practice", link: "/in-practice" },
];
